import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import '@/assets/chlebalize.min.css'
import '@/assets/fonts.css'
import '@/assets/style.css'
import '@/assets/style_bootstrap.css'


createApp(App).use(router).mount('#app')
